import {useEffect} from "react";
import {addBreadcrumb, setToken} from "../utils/auth";
import {useAppStore} from "../store/appStore";
import {setUserProperties} from "firebase/analytics";
import {firebaseAnalytics} from "../firebaseConfig";
import {setTag} from "@sentry/react";


export const useTokenFromURL = () => {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get("token") ?? urlParams.get("Token");

        if (!urlToken) return;

        addBreadcrumb("[useTokenFromURL] Token found in URL parameters");
        console.info("[useTokenFromURL] Token found in URL parameters");

        setToken(urlToken);
        useAppStore.setState({isIntegration: true});
        setUserProperties(firebaseAnalytics, {auth_provider: 'integration'});
        setTag(`auth_provider`, 'integration')

        // Remove token from URL
        urlParams.delete("token");
        urlParams.delete("Token");
        window.history.replaceState({}, document.title, window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : ""));
    }, []);
};
